import { GET_RATES, GET_CURRENCIES } from '../actionTypes'
import { Rate, Currency } from '../reducers/currency'

export const getCurrenciesAction = (currencies: Currency[]) => ({ type: GET_CURRENCIES, payload: currencies })
export const getRatesAction = (rates: Rate[]) => ({ type: GET_RATES, payload: rates })
